// // external imports
// import { configureStore } from '@reduxjs/toolkit';

// // internal imports
// import apiSlice from '../features/api/apiSlice';
// import authSlice from '../features/auth/authSlice';
// import menuSlice from 'features/menu/menuSlice';
// import teamSlice from 'features/team/teamSlice';
// import teamMemberSlice from 'features/team-member/teamMemberSlice';
// import planSlice from 'features/plan/plan';
// import projectSlice from 'features/project/projectSlice';
// import reportSlice from 'features/report/reportSlice';
// import promptSlice from 'features/prompt/promptSlice';
// import subscriptionSlice from 'features/subscription/subscriptionSlice';
// import mentionSlice from 'features/mention/mentionSlice';
// import aiModelSlice from 'features/ai-model/aiModelSlice';
// import snackbarSlice from 'features/snackbar/snackbar';

// // configure app store
// const store = configureStore({
//     reducer: {
//         auth: authSlice,
//         prompt: promptSlice,
//         project: projectSlice,
//         team: teamSlice,
//         teamMember: teamMemberSlice,
//         report: reportSlice,
//         subscription: subscriptionSlice,
//         mention: mentionSlice,
//         aiModel: aiModelSlice,
//         plan: planSlice,
//         menu: menuSlice,
//         snackbar: snackbarSlice,
//         [apiSlice.reducerPath]: apiSlice.reducer
//     },
//     middleware: (getDefaultMiddleware) =>
//         getDefaultMiddleware({
//             serializableCheck: false
//         }).concat(apiSlice.middleware)
// });

// export const { dispatch, getState } = store;
// // export app store
// export default store;
/* eslint-disable prettier/prettier */
/* eslint-disable no-unused-vars */

// external imports
import { configureStore } from '@reduxjs/toolkit';

// internal imports
import authSlice from '../features/auth/authSlice';
import menuSlice from 'features/menu/menuSlice';
import teamSlice from 'features/team/teamSlice';
import teamMemberSlice from 'features/team-member/teamMemberSlice';
import planSlice from 'features/plan/plan';
import projectSlice from 'features/project/projectSlice';
import reportSlice from 'features/report/reportSlice';
import promptSlice from 'features/prompt/promptSlice';
import subscriptionSlice from 'features/subscription/subscriptionSlice';
import mentionSlice from 'features/mention/mentionSlice';
import aiModelSlice from 'features/ai-model/aiModelSlice';
import snackbarSlice from 'features/snackbar/snackbar';

// configure the app store
const store = configureStore({
    reducer: {
        auth: authSlice,
        prompt: promptSlice,
        project: projectSlice,
        team: teamSlice,
        teamMember: teamMemberSlice,
        report: reportSlice,
        subscription: subscriptionSlice,
        mention: mentionSlice,
        aiModel: aiModelSlice,
        plan: planSlice,
        menu: menuSlice,
        snackbar: snackbarSlice
    },
    // Only default middleware needed now
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false // keep if you store non‑serializable data
        })
});

// convenience re‑exports
export const { dispatch, getState } = store;
export default store;
